<div class="announcement-bar">
  <p class="announcement-bar__text">{{ message }}</p>
</div>
